module.exports = __webpack_public_path__ + "img/20230711100304605mxe.de29ff77.png";